import { ExampleHeaderTypes } from "../common/types/ExampleHeaderTypes";

export const exampleHeaders: ExampleHeaderTypes[] = [
    { id: "row", label: "Sıra" },
    { id: "customercode", label: "Müşteri Kodu" },
    { id: "customername", label: "Müşteri Adı" },
    { id: "taxcode", label: "Vergi Numarası" },
    { id: "taxoffice", label: "Vergi Dairesi" },
    { id: "country", label: "Ülke" },
    { id: "city", label: "Şehir" },
    { id: "district", label: "İlçe" },
    { id: "postalcode", label: "Posta Kodu" },
    { id: "address", label: "Adres" },
    { id: "mobile", label: "Telefon" },
    { id: "phone", label: "Cep Tel." },
    { id: "email", label: "Email" },
    { id: "tccode", label: "TC Kimlik No"}
];